"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetBalanceBySafeAddress = exports.useWalletsByOwnerAddress = exports.validateSafeByAddress = exports.useWalletByAddress = void 0;
const addresses_1 = require("../utils/addresses");
const client_1 = require("@apollo/client");
const graphqlQueries_1 = require("./graphqlQueries");
let safe = undefined;
function useWalletByAddress(walletAddress, chainId, pollInterval) {
    const rawAddress = walletAddress ? (0, addresses_1.toRawAddress)(walletAddress) : "";
    const { loading, error, data, refetch } = (0, client_1.useQuery)(graphqlQueries_1.GET_SAFE, {
        variables: { chainId: chainId, safeAddress: rawAddress },
        pollInterval: pollInterval ?? 0,
    });
    // TODO: name refinement
    if (!loading && !error && data && data.safe) {
        if (!safe) {
            safe = {
                ...data.safe,
                walletId: data.safe.safeId,
            };
        }
        else {
            if (safe.safeId !== data.safe.safeId) {
                safe = {
                    ...data.safe,
                    walletId: data.safe.safeId,
                };
            }
        }
    }
    else {
        safe = undefined;
    }
    return { safeInfo: safe ?? undefined, error, loading, refetch };
}
exports.useWalletByAddress = useWalletByAddress;
const validateSafeByAddress = async (walletAddress, chainId, graphqlURI = "https://graphql.tonkey.app/graphql") => {
    try {
        const rawAddress = (0, addresses_1.toRawAddress)(walletAddress);
        const response = await fetch(`${graphqlURI}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                query: `query Safe($chainId: String!, $safeAddress: String!) {
          safe(chainId: $chainId, safeAddress: $safeAddress) {
            address
            chainId
            owners {
              address
              publicKey
            }
            safeId
            threshold
          }
        }`,
                variables: {
                    chainId: `${chainId}`,
                    safeAddress: `${rawAddress}`,
                },
            }),
        });
        if (response.status === 200) {
            const result = await response.json();
            if (result.error) {
                console.log(result.error);
                throw new Error("GraphQL API Failed");
            }
            if (result.data.safe === null)
                return false;
            return true;
        }
    }
    catch (e) {
        console.log(e);
    }
    return false;
};
exports.validateSafeByAddress = validateSafeByAddress;
function useWalletsByOwnerAddress(ownerAddress) {
    const rawAddress = ownerAddress ? (0, addresses_1.toRawAddress)(ownerAddress) : "";
    const { loading, error, data, refetch } = (0, client_1.useQuery)(graphqlQueries_1.GET_SAFE_LIST, {
        variables: { ownerAddress: rawAddress },
    });
    return {
        safeList: !loading && !error && data ? data.ownedSafes : [],
        error,
        loading,
        refetch,
    };
}
exports.useWalletsByOwnerAddress = useWalletsByOwnerAddress;
function useGetBalanceBySafeAddress(walletAddress, chainId, pollInterval) {
    const rawAddress = walletAddress ? (0, addresses_1.toRawAddress)(walletAddress) : "";
    const { loading, error, data, refetch } = (0, client_1.useQuery)(graphqlQueries_1.GET_BALANCE, {
        variables: { chainId: chainId, safeAddress: rawAddress },
        pollInterval: pollInterval ?? 0,
    });
    return {
        data: !loading && !error && data ? data.balance : undefined,
        error,
        loading,
        refetch,
    };
}
exports.useGetBalanceBySafeAddress = useGetBalanceBySafeAddress;
